import React from 'react';
import LocationMarker from './marker-location';

function LocationMarkers({
  zIndex,
  locations,
  onClick,
  onClose,
  onUpdateLocationTarget,
  selectedLocationId,
  activeLocations,
  currentRoute,
  fetchRouteById,
}) {
  return (
    <>
      {locations.map((location) => (
        <LocationMarker
          key={location._id}
          location={location}
          onClick={onClick}
          onUpdateLocationTarget={onUpdateLocationTarget}
          isSelected={selectedLocationId === location._id}
          onClose={onClose}
          zIndex={zIndex}
          activeLocations={activeLocations}
          isBuildingRoute={!!activeLocations}
          currentRoute={currentRoute}
          fetchRouteById={fetchRouteById}
          locationIndex={activeLocations ? activeLocations.indexOf(location) : -1}
        />
      ))}
    </>
  );
}

export default LocationMarkers;
